import { InspectorControls, useBlockProps } from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";
import FormInputStylesControls, { getInputStyleVars } from '../../../components/FormInputStylesControls';

import "../style.scss";

export default function Edit(props) {
  return (
    <>
      <InspectorControls>
        <AllInspectorSettings {...props} />
        <FormInputStylesControls {...props} />
      </InspectorControls>
      <Content {...props} />
    </>
  );
}

function renderPlaceholder(placeholder, clickText, inputId) {
  if (!placeholder) return null;

  const parts = placeholder.split("{click}");
  if (parts.length === 1) return <span>{placeholder}</span>;

  return (
    <span>
      {parts[0]}
      <label htmlFor={inputId} className="wp-block-brandy-form-upload__click-label">
        {clickText || "click"}
      </label>
      {parts[1]}
    </span>
  );
}

export function Content({ attributes, isSave = false }) {
  const {
    name,
    isRequired,
    label,
    id,
    accept,
    placeholder,
    placeholderClickText,
    maxFiles,
    maxFileSizeMB,
  } = attributes;

  const blockProps = isSave ? useBlockProps.save() : useBlockProps();
  const inputVars = getInputStyleVars(attributes.style && attributes.style.inputStyles);
  const allowMultiple = Number(maxFiles) > 1;
  const fieldName = allowMultiple && name && !name.endsWith("[]") ? `${name}[]` : name;
  return (
    <div {...blockProps} style={{ ...blockProps.style, ...inputVars }}>
      {label && (
        <label className="wp-block-brandy-form-label" htmlFor={id}>
          {label}
          {isRequired && (
            <abbr className="required" title="required">
              *
            </abbr>
          )}
        </label>
      )}
      <div className="wp-block-brandy-form-upload__dropzone">
        {isSave && (
          <input
            className="wp-block-brandy-form-field wp-block-brandy-form-upload__input"
            type="file"
            id={id}
            name={fieldName}
            accept={accept}
            required={isRequired}
            multiple={allowMultiple || undefined}
            data-max-files={maxFiles}
            data-max-file-size-mb={maxFileSizeMB}
            title=""
          />
        )}
        <div className="wp-block-brandy-form-upload__placeholder">
          {renderPlaceholder(placeholder, placeholderClickText, id)}
        </div>
      </div>
      {isSave && (
        <div className="wp-block-brandy-form-upload__error" role="alert" aria-live="polite"></div>
      )}
    </div>
  );
}
